import React from 'react'

import { DeltaValue } from '@/shared/components/ui/delta-value'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

export function BasicPercentField({
	value,
	ref,
}: {
	value: number | null | undefined
	ref?: React.Ref<HTMLDivElement>
}) {
	if (value === null || value === undefined) {
		return (
			<div ref={ref} className='cell-data-number'>
				-
			</div>
		)
	}

	return (
		<DeltaValue value={value}>
			<div ref={ref} className='cell-data-number'>
				{formatNumber(value, NumberFormats.Fixed)}
			</div>
		</DeltaValue>
	)
}
